import React from 'react';
import styles from './ApplicationDocumentDownloadSnackbar.module.scss';
import { ApplicationDocumentFile } from 'api/LoanOriginationSystem/DocumentsApi';
import { useDispatch, useSelector } from 'react-redux';
import { ReduxState } from 'types/redux';
import LoaderWithState, { LoaderState } from 'components/LoaderWithState';
import { DocumentDownloadingState } from 'LoanOriginationSystemApplicationPage/Documents/Types';
import { FileIcon } from 'static/images';
import { iconsByExtension } from 'components/LoanOriginationSystem/ApplicationTabs/DocumentsTab/ApplicationDocumentsTable/ApplicationDocumentItemRow/ApplicationDocumentItemRow';
import { removeDownloadedDocument } from 'LoanOriginationSystemApplicationPage/Documents/ActionCreator';
import { DOCUMENT_DOWNLOADING_SNACK_LIFE_DURATION } from 'Snackbar/Middleware';
import { getAbbreviatedTextLine } from 'utils/getAbbreviatedString';

export interface ApplicationDocumentDownloadSnackbarProps {
  document: ApplicationDocumentFile;
  documentDownloadingId: string;
}

const MAX_DOCUMENT_NAME_LENGTH = 38;

const ApplicationDocumentDownloadSnackbar = ({
  document,
  documentDownloadingId,
}: ApplicationDocumentDownloadSnackbarProps) => {
  const dispatch = useDispatch();

  const documentDownloadingState: DocumentDownloadingState = useSelector(
    (state: ReduxState) => state.loanOriginationSystemDocuments.downloadableDocuments[documentDownloadingId],
  );

  const onDocumentDownloadingStateReset = () => {
    dispatch(removeDownloadedDocument(documentDownloadingId));
  };

  return (
    <div className={styles.documentContainer}>
      <div className={styles.documentIcon}>{iconsByExtension.get(document.extension) || <FileIcon />}</div>
      <div className={styles.documentName}>{getAbbreviatedTextLine(document.name, MAX_DOCUMENT_NAME_LENGTH)}</div>
      <LoaderWithState
        state={
          documentDownloadingState === 'loading' ? LoaderState.Updating : (documentDownloadingState as LoaderState)
        }
        onStateReset={onDocumentDownloadingStateReset}
        className={styles.loader}
        successTimeout={DOCUMENT_DOWNLOADING_SNACK_LIFE_DURATION}
        failureTimeout={DOCUMENT_DOWNLOADING_SNACK_LIFE_DURATION}
      />
    </div>
  );
};

export default ApplicationDocumentDownloadSnackbar;
